// extracted by mini-css-extract-plugin
module.exports = {"lds-ring":"SmallLoadingCircle_lds-ring__3MBmp"};